import React, { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { selectLocale } from 'models/localization';
import styled, { keyframes } from 'styled-components';
import ReactHtmlParser from 'react-html-parser';
import findAvailableLocale from 'models/helpers/findAvailableLocale';

import LandingPageContent from './LandingPageContent';

const fadeInBottom = keyframes`
  0% {
    opacity: 0;
    transform: translateY(30px);
  }

  80% {
    opacity: 0;
    transform: translateY(30px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const EventEndText = styled.div`
  width: min(960px, 90vw);
  text-align: center;
  color: #FFF;
  animation: ${fadeInBottom} 3s ease-in;
`;

const EventEndContent: FC = () => {
  const locale = useSelector(selectLocale);
  const { t } = useTranslation();
  const { landing: { postEventMessage } } = useSelector((state: any) => state.eventConfigs);
  const defaultEventMessage = useMemo(() => ReactHtmlParser(`
    <h1>${t('landing.event_finished', 'Event Has Ended')}</h1>
    <h1>${t('lobby.see_you_next_time', 'See You Next Time')}</h1>
  `), [t]);
  const localizedMessage = useMemo(() => findAvailableLocale(postEventMessage, locale), [locale]);

  return (
    <LandingPageContent id="event-end-content">
      <EventEndText id="event-end-text">
        {localizedMessage ? ReactHtmlParser(localizedMessage) : defaultEventMessage}
      </EventEndText>
    </LandingPageContent>
  );
};

export default React.memo(EventEndContent);
